interface AuthDividerProps {
  label?: string;
  /** `caps` is the small spaced-out section label; `plain` reads as a sentence. */
  variant?: 'caps' | 'plain';
}

export const AuthDivider = ({ label = 'or', variant = 'caps' }: AuthDividerProps) => {
  return (
    <div className="flex items-center my-3">
      <div className="flex-1 border-t border-white/10" />
      <span
        className={`mx-3 ${variant === 'caps' ? 'text-[11px] text-greyP3 uppercase tracking-[0.18em]' : 'text-xs text-greyP2'}`}
      >
        {label}
      </span>
      <div className="flex-1 border-t border-white/10" />
    </div>
  );
};
